<div class="absolute left-0 top-0 h-full w-full">
  <div
    class="absolute bottom-5 right-5 z-50 flex h-fit w-[376px] flex-col justify-between rounded-lg bg-[#067F75]/70 p-3 text-white backdrop-blur-sm"
  >
    <div>
      <div class="relative flex items-center justify-between">
        <div class="flex items-center gap-2 font-bold">
          <svg-icon
            src="icons/doctor.svg"
            class="fill-white"
            [svgStyle]="{ 'height.px': 20 }"
          />
          {{ aiXpert.title() }}
        </div>
        @if (aiXpert.idle()) {
          <img
            src="animations/think.gif"
            style="width: 32px; height: 32px"
            class="absolute -right-1 -top-1"
          />
        }
      </div>
      <div class="my-3">
        {{ aiXpert.answer() }}
      </div>
    </div>
    <button
      class="w-full rounded-md bg-white p-2 font-bold text-green-700"
      (click)="closeSimXpert.emit()"
    >
      Close SimXpert
    </button>
  </div>
</div>
